import httpClient from "../../../shared/api/httpClient";

// Leitura do perfil já vem de useAuth() (query ["auth","me"]) — esta API só cobre a
// escrita, para não duplicar a query de leitura que o contexto de auth já mantém.
export const perfilApi = {
  update: ({ nomeCompleto, especialidade, crm, razaoSocialPj, cnpjPj, emailNotificacao, regimeTributario }) =>
    httpClient
      .patch("/api/v1/me/perfil", {
        nome_completo: nomeCompleto,
        especialidade,
        crm,
        razao_social_pj: razaoSocialPj,
        cnpj_pj: cnpjPj,
        email_notificacao: emailNotificacao,
        regime_tributario: regimeTributario,
      })
      .then((r) => r.data.dados),
};
